jQuery(function($) {
  $('.mapLink').on('click', function(e) {
    const el = $(this);
    const location = el.data('location');
    const v2 = el.data('mapv2');
    const searchUri = '/sitebuilder2/api/campus_map/location/';
    const oldIdUri = '/sitebuilder2/api/campus_map/slid/'

    e.preventDefault();
    e.stopPropagation();

    if (location && !el.attr("aria-describedby")) {
      const slid = el.data('slid');
      const locationId = el.data('location-id')
      let url = v2 ? `${searchUri}${encodeURIComponent(locationId)}` : `${oldIdUri}${encodeURIComponent(location)}`;

      if (!v2 && slid != null) {
        url = url + "?slid=" + encodeURIComponent(slid);
      }
      // SBTWO-11382 Open map in a new tab instead of displaying the map in a popup
      window.open(url, "_blank")
    }
  });
});
